import { ParsedUrlQuery } from "querystring"
import { useContext } from "react"
import { EnvContext } from "../components/EnvContext"

export const useIsKids = () => {
  const env = useContext(EnvContext)
  if (!env) throw new Error("EnvContext not found")
  return env.isKids
}

export const useIsKidsPreview = () => {
  const env = useContext(EnvContext)
  if (!env) throw new Error("EnvContext not found")
  return env.isKidsPreview
}

export function getIsKids(query: ParsedUrlQuery) {
  return query.__subdomain === "kids" || query.__kidsPreview === "true"
}

export function getIsKidsPreview(query: ParsedUrlQuery) {
  return query.__kidsPreview === "true"
}
